import { MRT_ColumnDef } from 'material-react-table';
import NameCellWithImage, { ChipCell } from 'components/controls/image-cell';
import { useWorkspace } from 'hooks/useWorkspace';
import { useTranslation } from 'react-i18next';
import { PRODUCT_STATUS_COLOR } from './status';
import { useMemo } from 'react';
import { ToolTip } from 'components/controls';

export type ProductsColumns = {
    id: string;
    name: string;
    price: string;
    discountedPrice: string;
    createdAt: string;
    placeId: string;
};

export const useProductTableColumns = (): MRT_ColumnDef<ProductsColumns>[] => {
    const { t } = useTranslation();
    const { baseWorkspaceUrl } = useWorkspace();

    return useMemo(
        () => [
            {
                accessorKey: 'name',
                header: t('TABLE_HEADERS.NAME'),
                enableColumnActions: false,
                enableSorting: false,
                Cell: ({ cell }) => {
                    const path = `${baseWorkspaceUrl}/product/${cell.row.original.placeId}/edit/${cell.row.original.id}`;
                    return (
                        <ToolTip
                            disableHoverListener={cell.row.original['name'].length < 42}
                            title={cell.getValue<string>()}
                            placement="top-end"
                        >
                            <NameCellWithImage cell={cell} showImage isLink path={path} target="_self" />
                        </ToolTip>
                    );
                },
                size: 320,
            },
            {
                id: 'productCategoryId',
                accessorKey: 'productCategoryName',
                header: t('TABLE_HEADERS.CATEGORY'),
                filterVariant: 'autocomplete',
                enableColumnActions: false,
                enableSorting: false,
                size: 150,
            },
            {
                accessorKey: 'price',
                header: t('TABLE_HEADERS.PRICE'),
                enableColumnActions: false,
                enableColumnFilter: false,
                size: 100,
            },
            {
                accessorKey: 'discountedPrice',
                header: t('TABLE_HEADERS.DISCOUNTED_PRICE'),
                enableColumnActions: false,
                enableColumnFilter: false,
                size: 100,
            },
            {
                accessorKey: 'isAvailable',
                header: t('TABLE_HEADERS.AVAILABILITY'),
                enableColumnActions: false,
                enableColumnFilter: false,
                size: 150,
                Cell: ({ cell }) => (
                    <ChipCell
                        value={cell.getValue<string>()}
                        statusColorMap={PRODUCT_STATUS_COLOR}
                        translationKey="STATUS"
                    />
                ),
            },
            {
                accessorKey: 'createdAt',
                header: t('TABLE_HEADERS.CREATION_DATE'),
                enableColumnActions: false,
                enableColumnFilter: false,
                size: 100,
            },
        ],
        [t, baseWorkspaceUrl],
    );
};
